import React from 'react';
import './TabSettings.css';

const TabSettings = ({ element, elements, onUpdate }) => {
  // Find all tab buttons and content elements
  const tabMenuElement = elements.find(el => el.parentId === element.id && el.type === 'div');
  const tabContentElement = elements.find(el => el.id === element.children[1]);
  const tabButtons = elements.filter(el => el.parentId === tabMenuElement?.id && el.type === 'button');

  const handleAddNewTab = () => {
    const newTabNumber = tabButtons.length + 1;
    
    // Create new tab content first
    const newTabContent = {
      id: Date.now(),
      builderId: `builder-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      type: 'div',
      text: `Tab ${newTabNumber} Content`,
      styles: {
        display: 'block',
        padding: '20px',
        backgroundColor: '#f8f9fa',
        borderRadius: '4px'
      },
      children: [],
      parentId: tabContentElement.id,
      visibility: 'visible',
      tabGroupId: tabButtons[0].tabGroupId
    };

    // Then create new tab button with reference to its content
    const newTabButton = {
      id: Date.now() + 1,
      builderId: `builder-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      type: 'button',
      text: `Tab ${newTabNumber}`,
      className: 'Tab active',
      styles: {},
      children: [],
      parentId: tabMenuElement.id,
      visibility: 'visible',
      relatedContentId: newTabContent.id,
      byDefault: false,
      tabGroupId: tabButtons[0].tabGroupId
    };

    // Update elements array with new tab elements
    const updatedElements = elements.map(el => {
      if (el.id === tabMenuElement.id) {
        return {
          ...el,
          children: [...el.children, newTabButton.id]
        };
      }
      if (el.id === tabContentElement.id) {
        return {
          ...el,
          children: [...el.children, newTabContent.id]
        };
      }
      // Remove active class from other tabs
      if (el.parentId === tabMenuElement.id && el.type === 'button') {
        return {
          ...el,
          className: 'Tab'
        };
      }
      // Hide other tab contents
      if (el.parentId === tabContentElement.id) {
        return {
          ...el,
          styles: {
            ...el.styles,
            display: 'none'
          }
        };
      }
      return el;
    });

    // Add new elements to the array
    onUpdate([...updatedElements, newTabButton, newTabContent]);
  };

  const handleTabClick = (selectedTab) => {
    // Update tab buttons classes (active/inactive states)
    const updatedElements = elements.map(el => {
      // Handle tab buttons
      if (el.parentId === tabMenuElement?.id && el.type === 'button') {
        if (el.id === selectedTab.id) {
          return {
            ...el,
            className: el.className.includes('active') ? el.className : 'Tab active',
            // byDefault: false // Remove default status when another tab is selected
          };
        } else {
          return {
            ...el,
            className: 'Tab',
            // byDefault: false
          };
        }
      }

      // Handle tab content visibility using relatedContentId
      if (el.parentId === tabContentElement.id) {
        return {
          ...el,
          styles: {
            ...el.styles,
            display: el.id === selectedTab.relatedContentId ? 'block' : 'none'
          }
        };
      }
      return el;
    });

    // Update all elements
    onUpdate(updatedElements);
  };

  return (
    <div className="tab-settings">
      <h4 className="tab-settings-title">Tabs</h4>
      <div className="tab-list">
        {tabButtons.map((tab, index) => (
          <div 
            key={tab.id}
            className={`tab-item ${tab.className?.includes('active') ? 'active' : ''}`}
            onClick={() => handleTabClick(tab)}
          >
            <span className="tab-name">{tab.text}</span>
            <span className="tab-badge">Tab {index + 1}</span>
          </div>
        ))}
      </div>
      <button 
        className="add-tab-button" 
        onClick={handleAddNewTab}
      >
        + Add New Tab
      </button>
    </div>
  );
};

export default TabSettings; 